import ScatterPinOverlay from './ScatterPinOverlay';
import {
    merge
} from'./../../../../tool/util';
const config = {
    symbol: 'circle', //'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'
    label: false,
    labelColor: null,
    labelSize: 12,
    labelPosition: 'right'
};

export default class ScatterCircleOverlay extends ScatterPinOverlay {
    constructor(opts) {
        super(merge(config, opts));
    }
}